import QuizStatuses from '@/constant/QuizStatuses'

// Quiz-slide detection lives in the leaderboard/isQuizSlide store getter (the single source
// of truth, resolving plugin types live). These pure helpers take that predicate so they
// share the exact same rule instead of re-deriving it from a denormalized slide.typeObj.
export const shouldShowLeaderboardVisibilityToggle = ({ slides, isLive, isQuizSlide }) => {
  if (!slides || slides.length == 0) return false
  return isLive && slides.some((slide) => isQuizSlide(slide))
}

// Ordered scored-slide ids up to and including `order`; the last id is the current slide.
export const quizSlideIdsUpTo = (slides, order, isQuizSlide) => {
  if (!slides) return []
  return slides
    .filter((slide) => isQuizSlide(slide) && (order === undefined || slide.order <= order))
    .sort((a, b) => a.order - b.order)
    .map((slide) => Number(slide.id))
}

export const shouldShowLeaderboardAfterQuizWhenPressNext = ({ slide }) => {
  return (
    slide &&
    slide.isLeaderboardEnabled &&
    slide.quizStatus === QuizStatuses.RESULT_SCREEN &&
    slide.type === 'pickAnswer'
  )
}
